import { animate } from 'animejs'

export default function animateStores() {
  animate('#logo_0', {
    opacity: [{ to: 1 }, { to: 0.2 }, { to: 1 }],
    duration: 4000,
    loop: true,
    ease: 'linear',
  })

  animate('#logo_1', {
    opacity: [{ to: 1 }, { to: 0.2 }, { to: 1 }],
    duration: 4200,
    loop: true,
    ease: 'linear',
  })

  animate('#logo_2', {
    opacity: [{ to: 1 }, { to: 0.2 }, { to: 1 }],
    duration: 4400,
    loop: true,
    ease: 'linear',
  })

  animate('#logo_3', {
    opacity: [{ to: 1 }, { to: 0.2 }, { to: 1 }],
    duration: 4600,
    loop: true,
    ease: 'linear',
  })

  animate('#logo_4', {
    opacity: [{ to: 1 }, { to: 0.2 }, { to: 1 }],
    duration: 4800,
    loop: true,
    ease: 'linear',
  })

  animate('#logo_5', {
    opacity: [{ to: 1 }, { to: 0.2 }, { to: 1 }],
    duration: 5000,
    loop: true,
    ease: 'linear',
  })

  animate('#logo_6', {
    opacity: [{ to: 1 }, { to: 0.2 }, { to: 1 }],
    duration: 5200,
    loop: true,
    ease: 'linear',
  })

  animate('#logo_7', {
    opacity: [{ to: 1 }, { to: 0.2 }, { to: 1 }],
    duration: 5400,
    loop: true,
    ease: 'linear',
  })

  animate('#logo_8', {
    opacity: [{ to: 1 }, { to: 0.2 }, { to: 1 }],
    duration: 5600,
    loop: true,
    ease: 'linear',
  })

  animate('#logo_9', {
    opacity: [{ to: 1 }, { to: 0.2 }, { to: 1 }],
    duration: 5800,
    loop: true,
    ease: 'linear',
  })

  animate('#logo_10', {
    opacity: [{ to: 1 }, { to: 0.2 }, { to: 1 }],
    duration: 6000,
    loop: true,
    ease: 'linear',
  })

  animate('#logo_11', {
    opacity: [{ to: 1 }, { to: 0.2 }, { to: 1 }],
    duration: 6200,
    loop: true,
    ease: 'linear',
  })

  animate('#logo_12', {
    opacity: [{ to: 1 }, { to: 0.2 }, { to: 1 }],
    duration: 6400,
    loop: true,
    ease: 'linear',
  })
}
